export const ROWS_PER_PAGE = 10
export const AVAILABLE_MODULE_PERMISSION = ['view', 'add', 'change', 'delete']
export const AVAILABLE_USER_PERMISSION = {
    LEADS: 'leads',
    GLOBAL_SETTING: 'globalsetting',
    PLATFORM_SETTING: 'platformsetting',
    PLATFORM: 'platform',
    YOUTUBE_LEADS: 'youtubeleads',
    ROLES: 'roles',
    USERS: 'applicationusers',
}
export const MODULE_PERMISSIONS = ['view', 'change', 'add', 'delete']
export const FULL_ACCESS = 'Full Access'
export const VIEW_ONLY = 'View Only'
export const ADD_UPDATE = 'Add & Update'
export const MODULE_CHANGE = 'change'
export const MODULE_ADD = 'add'
export const MODULE_VIEW = 'view'

export const AVAILABLE_INTEGRATIONS = [
    {
        key: "facebook",
        name: "Facebook",
    },
    {
        key: "youtube",
        name: "YouTube",
    },
    {
        key: "reddit",
        name: "Reddit",
    },
    {
        key: "instagram",
        name: "Instagram",
    },
]

export const IMAGE_INTEGRATIONS = [
    {
        key: "facebook",
        name: "Facebook",
    },
    {
        key: "reddit",
        name: "Reddit",
    },
    {
        key: "instagram",
        name: "Instagram",
    },
]
export const   VIDEO_INTEGRATIONS = [
    {
        key: "facebook",
        name: "Facebook",
    },
    {
        key: "youtube",
        name: "YouTube",
    },
    
    {
        key: "instagram",
        name: "Instagram",
    },
]
export const   BLOG_INTEGRATIONS = [
   
     {
        key: "reddit",
        name: "Reddit",
    },
   
]

export const LEAD_TYPE = [
    {
        key: 'hot_lead',
        name: "Hot Lead",
    },
    {
        key: 'cold_lead',
        name: "Cold Lead",
    },
    {
        key: 'neutral',
        name: "Neutral",
    },
]

export const FEED_TYPE = [
    {
        key: 'post',
        name: "Post",
    },
    {
        key: 'group_post',
        name: "Group Post",
    },
    {
        key: 'page_post',
        name: "Page Post",
    },
    {
        key: 'videos',
        name: "Videos",
    },
    {
        key: 'reels',
        name: "Reels",
    },
    {
        key: 'photos',
        name: "Photos",
    },

]

export const FEED_TYPE_YOUTUBE = [
    {
        key: 'videos',
        name: "Videos",
    }
]

export const DATE_FILTER = [
    {
        key: 'today',
        name: "Today",
    },
    {
        key: 'yesterday',
        name: "Yesterday",
    },
    {
        key: 'last_week',
        name: "Last 7 Days",
    },
    {
        key: 'last_month',
        name: "Last Month",
    },
    {
        key: 'last_year',
        name: "Last Year",
    },
]

export const LANDING_PAGE_DETAILS = [
    {
        routeKey: "roof-repair",
        title: "Best Roof Repair & New-Roofing Services",
        subtitle: "Welcome to RAYIQlive, your trusted partner for professional roof repair and new-roofing installations.We deliver durable solutions, expert craftsmanship, and timely service to protect your home for years to come.",
        videoURL: "https://rayiqlive-prod.s3.us-east-1.amazonaws.com/media/landing_page/roof-repair.mp4",
        formtitle: "Request a Roofing Inspection"
    },
    {
        routeKey: "window-repair",
        title: "Best Window Repairing & New-Window Installation",
        subtitle: "Welcome to RAYIQlive, your trusted partner for professional window-repairing and brand-new window installations. Quality work, timely service!",
        videoURL: "https://rayiqlive-prod.s3.us-east-1.amazonaws.com/media/landing_page/window+repair.mov",
        formtitle: "Request a Windows Inspection"
    }
]

export const FACEBOOK_FEED_TYPE = [

    {
        key: 'groups',
        name: "Groups",
    },
    {
        key: 'pages',
        name: "Pages",
    },
    {
        key: 'videos',
        name: "Videos",
    },
    {
        key: 'reels_and_photos',
        name: "Reels and Photos",
    }
]
export const YOUTUBE_FEED_TYPE = [
    {
        key: 'videos',
        name: "Videos",
    },
]
export const REDDIT_FEED_TYPE = [
    {
        key: 'posts',
        name: "Posts",
    },
]
export const INSTAGRAM_FEED_TYPE = [
    {
        key: 'posts',
        name: "Posts",
    },
]
export const LEADS_CATEGORY = [
    { key: "trend", name: "Trend" },
    { key: "question", name: "Question" },
    { key: "product_mention", name: "Product Mention" },
    { key: "competitor", name: "Competitor" },
    { key: "service_request", name: "Service Request" },
    { key: "general", name: "General" }
];

export const YOUTUBE_PLATFROM_SETTINGS =
    [
        { key: "SEARCH_KEYWORD", value: "", value_type: "text" },
        { key: "MAX_FEED", value: "", value_type: "number" },
        { key: "MAX_COMMENTS", value: "", value_type: "number" },
        // { key: "API_KEY", value: "", value_type: "password" }
    ]
export const COMMON_PLATFROM_SETTINGS =
    [
        { key: "SEARCH_KEYWORD", value: "", value_type: "text", name:"Search Keyword" },
        { key: "MAX_FEED", value: "", value_type: "number", name:"Max Feed" },
        { key: "MAX_COMMENTS", value: "", value_type: "number",  name:"Max Comments" },
    ]
export const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());